/* eslint-disable linebreak-style */
import React, { useEffect, useState } from 'react';
import getConfig from 'next/config';
import PropTypes from 'prop-types';
import { useAuth } from 'root/hooks/useAuth';
import useDeviceScreen from 'root/hooks/useDeviceScreen';
import apiClient from '../../lib/apiClient';
import GridPostsItem from './GridPostsItem';

const { publicRuntimeConfig = {} } = getConfig ? getConfig() : {};

const GridPosts = ({ widget }) => {
  const { isMobile } = useDeviceScreen();
  const [bookmarks, setBookmarks] = useState([]);
  const { stateUser } = useAuth();
  const { isAuthenticated } = stateUser;

  useEffect(() => {
    const getBookmarks = async () => {
      const result = await apiClient({ baseURL: publicRuntimeConfig.BASE_API_URL, method: 'GET', url: '/bookmarks/ids' });

      if (result.length > 0) setBookmarks(result.map(({ id }) => id));
    };

    if (isAuthenticated) {
      getBookmarks();
    }
  }, [isAuthenticated]);

  return (
    <section id="featured-posts">
      <div className="row">
        <div className="col-xs-12">
          <div className="section-title without-padding-left without-border">
            <span
              className="label main-color text-uppercase"
              dangerouslySetInnerHTML={{
                __html: widget.options.title
              }}
            />
          </div>
        </div>
        <div className="col-xs-12">
          <div className="big-slider">
            <GridPostsItem big key={widget.content[0]?.id} post={widget.content[0]} isAuthenticated={isAuthenticated} bookmarks={bookmarks} handleBookmarks={setBookmarks} />
          </div>
          <div className="horizontal-scroll-sm">
            {widget.content?.slice(1).map((post) => (
              <>
                {post.isBookmark}
                <GridPostsItem key={post.id} post={post} lazy={isMobile} isAuthenticated={isAuthenticated} bookmarks={bookmarks} handleBookmarks={setBookmarks} />
              </>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

GridPosts.defaultProps = {
  widget: {
    options: {},
    content: [],
  },
};

GridPosts.propTypes = {
  widget: PropTypes.object,

};

export default GridPosts;
